import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";

import { ComparisonFilterValue, ComparisonOperator } from "../menu/types";
import { ComparisonFilterEntry } from "../use-filter-state";
import {
  DATE_OPERATOR_LABEL_KEYS,
  NUMERIC_OPERATOR_LABEL_KEYS,
} from "./constants";

export default function ComparisonOperatorDropdown({
  entry,
  operatorLabel,
  onOperatorChange,
}: {
  entry: ComparisonFilterEntry;
  operatorLabel: string;
  onOperatorChange: (name: string, value: ComparisonFilterValue) => void;
}) {
  const { t } = useTranslation();
  const keys =
    entry.type === "DATE"
      ? DATE_OPERATOR_LABEL_KEYS
      : NUMERIC_OPERATOR_LABEL_KEYS;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="cursor-pointer rounded px-1 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
        >
          {operatorLabel}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="rounded-md border border-gray-200 bg-white p-1 shadow-lg"
          sideOffset={4}
          align="start"
        >
          {(Object.entries(keys) as [ComparisonOperator, string][]).map(
            ([operator, labelKey]) => (
              <DropdownMenu.Item
                key={operator}
                onSelect={() =>
                  onOperatorChange(entry.fieldName, {
                    operator,
                    value: entry.value,
                  })
                }
                className="flex cursor-pointer select-none items-center rounded-md px-3 py-1.5 text-xs text-gray-700 outline-none hover:bg-primary-50 focus:bg-primary-50"
              >
                {t(labelKey)}
              </DropdownMenu.Item>
            ),
          )}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
